import { Action } from '@ngrx/store';
import {
  User,
  UserCreate,
  Session,
  Wallet,
  Credentials,
  WelcomeVoucher,
  UserPricedrop,
  UserWishes,
  UserFollows
} from '@vestiaire/api-sdk-angular';
import { PopinAuthState } from '@app/core/user/store/reducers/user.reducers';
import { UserLikes } from '@vestiaire/api-sdk-angular';

export const RECONNECTUSER = '[User] try to reconnect user if he have session';

export const AUTHENTICATED = '[User] Get Current User';
export const AUTHENTICATED_SUCCESS = '[User] Get Current User success';
export const AUTHENTICATED_FAILURE = '[User] Get Current User failure';

export const LOGIN = '[User] Login';
export const LOGIN_SUCCESS = '[User] Login success';
export const LOGIN_FAILURE = '[User] Login failed';

export const GET_USER_WALLET = '[User] Check if User has Wallet and set wallet amount';

export const SET_USER_LIKED_ITEMS = '[User] SET User liked Items';
export const SET_USER_PRICE_DROP_FOLLOW_ITEMS = '[User] SET User Price Drop Follow Items';
export const ADD_USER_PRICE_DROP_FOLLOW_ITEMS = '[User] SET User Price Drop Follow Items';
export const REMOVE_USER_PRICE_DROP_FOLLOW_ITEMS = '[User] SET User Price Drop Follow Items';
export const ADD_LIKED_PRODUCT = '[User] add liked Product';
export const REMOVE_LIKED_PRODUCT = '[User] remove liked product';
export const ADD_LIKED_COMMENT = '[User] add liked Comment';
export const REMOVE_LIKED_COMMENT = '[User] remove liked Comment';
export const ADD_LIKED_BRAND = '[User] add liked Brand';
export const REMOVE_LIKED_BRAND = '[User] remove liked Brand';

export const SET_USER_WISHED_ITEMS = '[User] SET User wished Items';
export const ADD_USER_WISHED_ITEMS = '[User] ADD Item to user wishList';
export const REMOVE_USER_WISHED_ITEMS = '[User] REMOVE Item from user wishList';

export const REGISTER = '[User] Register';
export const OPEN_REGISTER_POPIN = '[User] Open Register popin';
export const OPEN_REGISTER_FORM = '[User] Register form';
export const REGISTER_SUCCESS = '[User] Register success';
export const REGISTER_FAILURE = '[User] Register failure';

export const LOGOUT = '[User] Logout';
export const LOGOUT_SUCCESS = '[User] Logout success';
export const LOGOUT_FAILURE = '[User] Logout failed';

export const RESET_STATE = '[User] Reset state';

export const POPIN_AUTH_SHOWED = '[Popin] Auth/Join or Register popin showed';

export const GET_WELCOME_VOUCHER = '[User] Load welcome voucher';
export const GET_WELCOME_VOUCHER_SUCCESS = '[User] Welcome voucher loaded';
export const GET_WELCOME_VOUCHER_FAILURE = '[User] Failed to load welcome voucher';

export const SET_USER_FOLLOW_MEMBER = '[User] SET User List following member';
export const ADD_USER_FOLLOW_MEMBER = '[User] ADD Member in user following list';
export const REMOVE_USER_FOLLOW_MEMBER = '[User] REMOVE Member from user following list';

/**
 * Checks if user has session.
 */
export class ReconnectUser implements Action {
  readonly type = RECONNECTUSER;
  constructor() {}
}

/**
 * Checks if user is authenticated.
 */
export class Authenticated implements Action {
  readonly type = AUTHENTICATED;
  constructor(public payload?: string) {}
}

/**
 * Authenticated check success.
 */
export class AuthenticatedSuccess implements Action {
  readonly type = AUTHENTICATED_SUCCESS;
  constructor(public payload: { authenticated: boolean; user: User | null }) {}
}

/**
 * Authenticated check error.
 */
export class AuthenticatedFailure implements Action {
  readonly type = AUTHENTICATED_FAILURE;
  constructor(public payload?: {}) {}
}

export class SetUserLikedItems implements Action {
  readonly type = SET_USER_LIKED_ITEMS;
  constructor(public payload: UserLikes) {}
}

export class GetWelcomeVoucher implements Action {
  readonly type = GET_WELCOME_VOUCHER;
  constructor(public payload: { authenticated: boolean }) {}
}

export class GetWelcomeVoucherSuccess implements Action {
  readonly type = GET_WELCOME_VOUCHER_SUCCESS;
  constructor(public payload: WelcomeVoucher) {}
}

export class GetWelcomeVoucherFailure implements Action {
  readonly type = GET_WELCOME_VOUCHER_FAILURE;
}

export class SetUserPriceDropFollow implements Action {
  readonly type = SET_USER_PRICE_DROP_FOLLOW_ITEMS;
  constructor(public payload: UserPricedrop) {}
}

export class AddUserPriceDropFollow implements Action {
  readonly type = ADD_USER_PRICE_DROP_FOLLOW_ITEMS;
  constructor(public payload: UserPricedrop) {}
}

export class RemoveUserPriceDropFollow implements Action {
  readonly type = REMOVE_USER_PRICE_DROP_FOLLOW_ITEMS;
  constructor(public payload: UserPricedrop) {}
}

export class SetUserWishedItem implements Action {
  readonly type = SET_USER_WISHED_ITEMS;
  constructor(public payload: UserWishes) {}
}

export class AddUserWishedItem implements Action {
  readonly type = ADD_USER_WISHED_ITEMS;
  constructor(public payload: UserWishes) {}
}

export class RemoveUserWishedItem implements Action {
  readonly type = REMOVE_USER_WISHED_ITEMS;
  constructor(public payload: UserWishes) {}
}

export class GetUserWallet implements Action {
  readonly type = GET_USER_WALLET;
  constructor(public payload: Wallet | null) {}
}

export class Login implements Action {
  readonly type = LOGIN;
  constructor(public payload: Credentials) {}
}

export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload: { session: Session; accountType?: string }) {}
}

export class LoginFailure implements Action {
  readonly type = LOGIN_FAILURE;
  constructor(public payload: any) {}
}

export class Logout implements Action {
  readonly type = LOGOUT;
  constructor() {}
}

export class LogoutSuccess implements Action {
  readonly type = LOGOUT_SUCCESS;
  constructor() {}
}
export class LogoutFailure implements Action {
  readonly type = LOGOUT_FAILURE;
  constructor(public payload: any) {}
}

export class Register implements Action {
  readonly type = REGISTER;
  constructor(public payload: UserCreate) {}
}

export class RegisterNewsletter implements Action {
  readonly type = OPEN_REGISTER_POPIN;

  constructor(public payload: PopinAuthState) {}
}

export class RegisterForm implements Action {
  readonly type = OPEN_REGISTER_FORM;
  constructor() {}
}

export class RegisterSuccess implements Action {
  readonly type = REGISTER_SUCCESS;
  constructor(public payload: { session: Session; accountType?: string }) {}
}

export class RegisterFailure implements Action {
  readonly type = REGISTER_FAILURE;
  constructor(public payload: any) {}
}

export class ResetState implements Action {
  readonly type = RESET_STATE;
}
export class PopinAuthShowed implements Action {
  readonly type = POPIN_AUTH_SHOWED;
  constructor(public payload: PopinAuthState) {}
}

export class SetUserFollowingMember implements Action {
  readonly type = SET_USER_FOLLOW_MEMBER;
  constructor(public payload: UserFollows) {}
}

export class AddUserFollowingMember implements Action {
  readonly type = ADD_USER_FOLLOW_MEMBER;
  constructor(public payload: UserFollows) {}
}

export class RemoveUserFollowingMember implements Action {
  readonly type = REMOVE_USER_FOLLOW_MEMBER;
  constructor(public payload: UserFollows) {}
}

export type All =
  | Authenticated
  | AuthenticatedSuccess
  | AuthenticatedFailure
  | SetUserLikedItems
  | SetUserPriceDropFollow
  | AddUserPriceDropFollow
  | RemoveUserPriceDropFollow
  | GetUserWallet
  | Login
  | LoginSuccess
  | LoginFailure
  | Logout
  | LogoutSuccess
  | LogoutFailure
  | Register
  | RegisterNewsletter
  | RegisterForm
  | RegisterSuccess
  | RegisterFailure
  | ResetState
  | GetWelcomeVoucher
  | GetWelcomeVoucherSuccess
  | GetWelcomeVoucherFailure
  | SetUserWishedItem
  | AddUserWishedItem
  | RemoveUserWishedItem
  | PopinAuthShowed
  | SetUserFollowingMember
  | AddUserFollowingMember
  | RemoveUserFollowingMember;
